import * as React from 'react';
// @ts-expect-error
import {Controller} from 'react-hook-form';
// @ts-expect-error
import type {Control, Watch} from 'react-hook-form';

import {Badge} from 'shells/badge/badge';
import {Checkbox} from 'shells/checkbox/checkbox';
import {Dialog} from 'shells/dialog/dialog';
// @ts-expect-error - imported from .js/.jsx file
import {CloseIcon} from 'shells/icon/svg/close-icon';
import {StaticTwoLineWithIcon} from 'shells/list-row/static-two-line-with-icon';
import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';

import type {FormSchemaProperty} from '../../../../../core/nutshell-fields/types';
import {entityTypeOptions} from '../../../../helpers';
import type {InputFormField} from '../../../../types';

import styles from './textfield-field-wrapper.module.css';

type Props = {
    control: Control;
    name: string;
    field: InputFormField;
    fieldSchema: FormSchemaProperty;
    fieldMappingLabel: string;
    onRemoveField: () => void;
    watch: Watch;
    children: React.ReactElement<any>;
};

export function TextfieldFieldWrapper(props: Props) {
    const [isConfirmingDelete, setIsConfirmingDelete] = React.useState<boolean>(false);

    const typeOptions = [
        {value: 'INPUT', label: 'Dropdown'},
        {value: 'RADIO', label: 'Radio'},
    ];

    const deleteRef = React.useRef(null);

    const entityType = props.watch(`${props.name}.entityType`);

    const entityTypeValue = entityTypeOptions.find((option) => option.value === entityType);

    return (
        <div className={styles['field-wrapper-container']}>
            {props.field.isRemovable ? (
                <div className={styles['badge-container']}>
                    <Badge
                        contents={
                            // @ts-expect-error
                            <div ref={(node) => (deleteRef.current = node)}>
                                <CloseIcon size={8} fill='#fff' wrapWithDiv={false} />
                            </div>
                        }
                        onClick={(e) => {
                            // We need to stop this click from propagating and deselecting the field
                            e.stopPropagation();
                            setIsConfirmingDelete(true);
                        }}
                        color='grey'
                    />
                </div>
            ) : undefined}
            <div className={styles.header}>
                <StaticTwoLineWithIcon
                    title={<div className={styles.title}>{props.fieldMappingLabel}</div>}
                    subtitle={entityTypeValue ? entityTypeValue.label : ''}
                    icon={entityTypeValue ? entityTypeValue.icon : undefined}
                />
                {props.fieldSchema && props.fieldSchema.displayType === 'dropdown' ? (
                    <Controller
                        name={`${props.name}.type`}
                        control={props.control}
                        // @ts-expect-error
                        render={({field}) => {
                            const selectedValue = typeOptions.find(
                                (option) => option.value === field.value
                            );

                            return (
                                <div className={styles['display-selector']}>
                                    <SelectPickerGeneric
                                        {...field}
                                        options={typeOptions}
                                        value={selectedValue}
                                        // @ts-expect-error
                                        onChange={(value) => {
                                            field.onChange(value.value);
                                        }}
                                        isDark={true}
                                    />
                                </div>
                            );
                        }}
                    />
                ) : undefined}
            </div>
            {props.children}
            <div className={styles.footer}>
                <Controller
                    name={`${props.name}.isRequired`}
                    control={props.control}
                    defaultValue={props.field.isRequired}
                    // @ts-expect-error
                    render={({field}) => {
                        const {onChange, ...restProps} = field;
                        // Non-removable fields are always required
                        const onRequiredChange = props.field.isRemovable ? onChange : undefined;

                        return (
                            <div className={styles.required}>
                                <Checkbox
                                    {...restProps}
                                    onChange={onRequiredChange}
                                    label='Required'
                                    checked={field.value}
                                />
                            </div>
                        );
                    }}
                />
            </div>
            {isConfirmingDelete ? (
                <Dialog
                    anchor={deleteRef.current}
                    question='Are you sure you want to delete this field?'
                    primaryText='Yes, delete?'
                    secondaryText='No, don’t delete'
                    onPrimary={() => props.onRemoveField()}
                    onSecondary={() => setIsConfirmingDelete(false)}
                    isWarning={true}
                />
            ) : undefined}
        </div>
    );
}
